import React, { Component } from "react";
import {
  ThreeColumns,
  GraphSide,
  GraphSideText,
  GraphLayout,
  LayoutContent,
  XAxisLabel,
  YAxisLabel,
  GraphBackground,
  RedBox,
  YellowGreenBox,
  GreenBox,
  Graph,
  Dot,
  InfoBelowGraph,
  Landscape,
} from "./style.js";
import scatterplot from "./scatterplot";
import _ from "lodash";
import clsx from "clsx";

class ScatterPlot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: `scatterPlotId-${new Date().getTime()}${Math.floor(Math.random() * Math.pow(10, 18))}`,
      chartId: `scatterPlotChartId-${new Date().getTime()}${Math.floor(Math.random() * Math.pow(10, 18))}`,
      opportunityAreas: [],
      excellentAreas: [],
      rankedAreas: {},
      highlightRanks: [],
      mountedReady: this.props.ready,
    };
  }

  componentDidMount() {
    if (this.props.ready) {
      this.determineExcellentAndOpportunityAreas(this.props.data);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ready && !this.props.ready) {
      this.determineExcellentAndOpportunityAreas(nextProps.data);
    }
    if (this.props.ready && JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data)) {
      this.determineExcellentAndOpportunityAreas(nextProps.data);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.ready && !prevProps.ready) {
      this.draw({});
    }
    if (this.state.mountedReady) {
      this.setState({
        mountedReady: false,
      });
      this.draw({});
    }
    if (prevProps.ready && JSON.stringify(this.props.data) !== JSON.stringify(prevProps.data)) {
      this.draw({updateData:true});
    }
  }

  determineExcellentAndOpportunityAreas(data) {
    const distances = [];
    for (let i = 0; i < data.points.length; i++) {
      const point = data.points[i];
      distances.push({
        name: point.key,
        isRed: point.values[0].x <= 60 && point.values[0].y <= 60,
        isGreen: point.values[0].x >= 70 && point.values[0].y >= 70,
        distanceFromOrigin: Math.sqrt(Math.pow(point.values[0].x, 2) + Math.pow(point.values[0].y, 2)),
        distanceFromTopRight: Math.sqrt(Math.pow(100 - point.values[0].x, 2) + Math.pow(100 - point.values[0].y, 2)),
      });
    }
    const distancesFromOrigin = _.sortBy(distances, "distanceFromOrigin");
    const distancesFromTopRight = _.sortBy(distances, "distanceFromTopRight");
    const opportunityAreas = [];
    const excellentAreas = [];
    let i = 0;
    while (opportunityAreas.length < 5 && i < distancesFromOrigin.length) {
      const dataPoint = distancesFromOrigin[i];
      if (dataPoint.isRed) {
        opportunityAreas.push(dataPoint.name);
      }
      i += 1;
    }
    i = 0;
    while (excellentAreas.length < 5 && i < distancesFromTopRight.length) {
      const dataPoint = distancesFromTopRight[i];
      if (dataPoint.isGreen) {
        excellentAreas.push(dataPoint.name);
      }
      i += 1;
    }
    const rankedAreas = {};
    const highlightRanks = [];
    for (let i = 0; i < distancesFromTopRight.length; i++) {
      const label = (i + 1).toString();
      rankedAreas[distancesFromTopRight[i].name] = label;
      highlightRanks.push(label);
    }
    this.setState({
      opportunityAreas,
      excellentAreas,
      rankedAreas,
      highlightRanks,
    });
  }

  draw({updateData}) {
    const { state, props } = this;
    const data = JSON.parse(JSON.stringify(props.data));
    _.forEach(data.points, function (point) {
      point.values[0].key = point.key;
      if (props.unit) {
        point.values[0].label = state.rankedAreas[point.values[0].label];
        if (point.key === props.unit.name && props.displayType === "Work Settings") {
          point.color = "#000";
        }
      }
    });
    data.points = _.sortBy(data.points, function (point) {
      return point.color;
    });
    const id = `#${state.id}`;
    const chartId = state.chartId;
    const dataPoints = data ? data.points : [];
    const allYearsData = props.allYearsData;
    const unitMappings = props.summaryReport.comparativeUnitMappings
    const selectedYear = props.selectedYear;
    const options = {
      title: props.title || "",
      highlightedItems:
        props.displayType === "Positions" && props.unit ? state.highlightRanks : props.highlightedItems || [],
      domainX: props.domainX || "",
      domainY: props.domainY || "",
      questionX: props.questionX || "",
      questionY: props.questionY || "",
      surveyPeriod: props.surveyPeriod || "",
      hospitalName: props.hospitalName || "",
      workSettings: props.workSettings || "",
      departments: props.departments || "",
      positions: props.positions || "",
      domain: props.domain || false,
    };
    if (updateData) {
      scatterplot.updateData(id, dataPoints, unitMappings, selectedYear);
    } else {
      scatterplot.draw(id, chartId, dataPoints, allYearsData, unitMappings, selectedYear, options);
    }
  }

  render() {
    const { unit, displayType, ready, summaryReport, landscape, configuration } = this.props;
    const { actualSurvey, datasetName } = summaryReport;
    const { opportunityAreas, excellentAreas } = this.state;

    const plotWorkSettings = displayType === "Work Settings";
    const plotPositions = displayType === "Positions";

    let showUnitBasedOnOfResultSetId = false;
    if (plotWorkSettings && configuration && configuration.scatterplots) {
      const regex = configuration.scatterplots.showUnitResultSetIdRegex;
      showUnitBasedOnOfResultSetId = regex && new RegExp(regex).test(summaryReport.resultSetId);
    }

    const rankedAreas = _.map(
      _.sortBy(_.toPairs(this.state.rankedAreas), function (area) {
        return parseInt(area[1], 10);
      }),
      function (area) {
        return area[0];
      }
    );
    const opportunityAreasHtml = [];
    const excellentAreasHtml = [];
    const rankedAreasHtml = [];
    for (let i = opportunityAreas.length - 1; i >= 0; i--) {
      opportunityAreasHtml.push(
        <GraphSideText key={`opportunity-${i}`} title={opportunityAreas[i]}>
          {opportunityAreas[i]}
        </GraphSideText>
      );
    }
    if (landscape) {
      opportunityAreasHtml.reverse();
    }
    for (let i = 0; i < excellentAreas.length; i++) {
      excellentAreasHtml.push(
        <GraphSideText key={`excellence-${i}`} title={excellentAreas[i]}>
          {excellentAreas[i]}
        </GraphSideText>
      );
    }
    for (let i = 0; i < rankedAreas.length; i++) {
      rankedAreasHtml.push(
        <GraphSideText key={`ranked-${i}`} title={rankedAreas[i]}>{`${i + 1}. ${rankedAreas[i]}`}</GraphSideText>
      );
    }

    const sutter = /SUTTER_Pulse/.test(actualSurvey);
    const sutter2018 = _.includes(
      ["SUTTER_Pulse", "SUTTER_Pulse_PhysicianAcute", "SUTTER_Pulse_PhysicianAmb"],
      actualSurvey
    );
    const showOpportunityAndExcellence = !unit && (!sutter2018 || plotPositions) && !showUnitBasedOnOfResultSetId;
    const showUnit =
      !showOpportunityAndExcellence && plotWorkSettings && (!sutter || unit || showUnitBasedOnOfResultSetId);
    const showRankedAreas = !showOpportunityAndExcellence && plotPositions && (!sutter || unit);
    let datasetUnitName;
    if (plotWorkSettings && summaryReport.datasetUnitNamePlural) {
      datasetUnitName = summaryReport.datasetUnitNamePlural;
    } else if (plotWorkSettings && configuration && configuration.scatterplots && configuration.scatterplots.unitName) {
      datasetUnitName = configuration.scatterplots.unitName;
    } else {
      datasetUnitName = displayType;
    }

    const leftSide = showOpportunityAndExcellence && (
      <GraphSide
        className={clsx("left-side", {
          portrait: !landscape,
          pulse: this.props.questionY && !landscape,
          below: landscape,
        })}
      >
        {landscape ? (
          <React.Fragment>
            <GraphSideText className={clsx("header", "opportunity")}>
              {opportunityAreasHtml.length > 0 && `${datasetUnitName} With Opportunity`}
            </GraphSideText>
            {opportunityAreasHtml}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {opportunityAreasHtml}
            <GraphSideText className="header opportunity">
              {opportunityAreasHtml.length > 0 && `${datasetUnitName} With Opportunity`}
            </GraphSideText>
          </React.Fragment>
        )}
      </GraphSide>
    );
    const graph = (
      <GraphLayout className={clsx({ portrait: !landscape })}>
        {this.props.domainY && <YAxisLabel>{this.props.domainY}</YAxisLabel>}
        {this.props.questionY && (
          <YAxisLabel className="question">
            <span dangerouslySetInnerHTML={{ __html: this.props.questionY }} />
          </YAxisLabel>
        )}
        <LayoutContent>
          <div />
          <GraphBackground>
            <RedBox />
            <YellowGreenBox />
            <GreenBox />
          </GraphBackground>
          {ready ? <Graph key={this.state.id} id={this.state.id} /> : <Graph />}
          {this.props.domainX && <XAxisLabel>{this.props.domainX}</XAxisLabel>}
          {this.props.questionX && <XAxisLabel className="question">{this.props.questionX}</XAxisLabel>}
        </LayoutContent>
      </GraphLayout>
    );
    const rightSide = (
      <GraphSide
        className={clsx({
          "right-side": showOpportunityAndExcellence || !landscape,
          portrait: !landscape,
          below: landscape,
        })}
      >
        <GraphSideText className={`header ${showOpportunityAndExcellence ? "excellence" : ""}`}>
          {showOpportunityAndExcellence && excellentAreasHtml.length > 0 && `${datasetUnitName} With Strengths`}
          {showOpportunityAndExcellence ? "" : sutter && plotWorkSettings ? "Groups" : datasetUnitName}
        </GraphSideText>
        {showOpportunityAndExcellence && excellentAreasHtml}
        {showUnit && (
          <div style={{ position: "relative", marginTop: "4px" }}>
            <Dot />
            <GraphSideText style={{ marginLeft: "20px" }}>{sutter ? datasetName : unit.name}</GraphSideText>
          </div>
        )}
        {showRankedAreas && rankedAreasHtml}
      </GraphSide>
    );

    return landscape ? (
      <Landscape>
        {graph}
        <InfoBelowGraph>
          {leftSide}
          {rightSide}
        </InfoBelowGraph>
      </Landscape>
    ) : (
      <ThreeColumns>
        {leftSide}
        {graph}
        {rightSide}
      </ThreeColumns>
    );
  }
}

export default ScatterPlot;



// WEBPACK FOOTER //
// ./src/components/ScatterPlot/index.js